export const EMPTY_VALUE = null;

//# sourceMappingURL=empty-values.js.map